var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view-login"},[_c('div',{staticClass:"container"},[_c('ul',[_c('li',[_c('button',{staticClass:"button",on:{"click":_vm.signInWithFb}},[_vm._v("Log in with Facebook")])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"button",on:{"click":_vm.signInWithGoogle}},[_vm._v("Log in with Google")])]),_vm._v(" "),_c('li')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f0fcae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 